import React, { memo } from 'react'
import { Col } from 'react-grid-system'
import { Card } from '../..'
import { CardsProps } from './types'

const Cards = ({
   data,
   onCardClick,
   onDeleteClick,
   onViewItemsClick,
   isEmployeeUser,
   tableType,
   currentUserEmail,
}: CardsProps) => (
   <>
      {data.map((d) => (
         <Col key={tableType === 'Connections' ? d.ID : d.Id} xs={12} xl={6}>
            <Card
               data={{
                  ...d,
                  type: tableType,
               }}
               onCardClick={onCardClick}
               onDeleteClick={onDeleteClick}
               onViewItemsClick={onViewItemsClick}
               isEmployeeUser={isEmployeeUser}
               currentUserEmail={currentUserEmail}
            />
         </Col>
      ))}
   </>
)

export default memo(Cards)
